import { useCallback, useEffect, useState } from "react";
import AreaService from "../../services/AreaService";
import { ReferenceModelNameEnums } from "../../enums/ReferenceModelNameEnums";
import { Box, Button, MenuItem, Paper, TableContainer, TableHead, TableRow } from "@mui/material";
import { FIlterHeader, FilterContainer, FilterSection, FilterTextField, SectionHeader, SectionTitle, StyledTable, TableHeader, TableWrapper, WorkSpaceTitleRow } from "../../styles/commonStyles";
import { FilterIcon } from "../Svg";
import CircularLoader from "./CircularLoader";
import CookServeTable from "./CookServeTable";
import EmptyListPlaceholder from "./EmptyListPlaceholder";
import { DatePicker } from "@mui/x-date-pickers";
import { CookSlotTimeEnumArray } from "../../enums/CookSlotTimeEnum";
import moment from "moment";
import { formatDate } from "../../utils/DateTimeUtils";
import EventBus from "../../EventBus";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import { CustomSnackbarTypes } from "./CustomSnackBar";
import ServeListSlotsDialog from "./ServeListSlotsDialog";
import { CookService } from "../../services/CookServices";
import { useRecordContext } from "react-admin";
import AssignCookServeList from "./AssingnCookServeList";
import AssignCookOnTrialServeList from "./AssignCookOnTrailServeList";
import CustomerPreferenceSummary from "../Customers/CustomerPreferenceSummary";

const areaService =new AreaService();
const cookService =new CookService();

const CookServeList=(props:any)=>{
    const record = useRecordContext()
    const [serviceId,setServiceId]=useState<any>(props?.hasService?props?.serviceId:1);
    const [loading,setLoading]=useState<boolean>(false);
    const [cookLoading,setCookLoading]=useState<boolean>(false);
    const [subData,setSubData]=useState<any[]>([]);
    const [cookData,setCookData]=useState<any>({});
    const [dialogOpen,setDialogOpen]=useState<boolean>(false);
    //if we are checking serivice List in house Tab
    const [cook,setCook]=useState<any>(null)
    const [slots,setSlots]=useState<any[]>([])

    const [date, setDate] = useState<Date>(new Date());
    const [time,setTime] = useState<any>(null);
    const [totalPeople,setTotalPeople] = useState<number>(1);
    const [clicked,setClicked]=useState<boolean>(false)
    const [assignCookOpen,setAssignCookOpen]=useState<boolean>(false)


    const handleReset=()=>{
        setDate(new Date());
        setTime(null);
        setTotalPeople(1);
        setCookData({})
        setClicked(false)
    }
    useEffect(() => {
        setLoading(true);
        areaService
            .getAllServices()
            .then((res) => {
                setSubData(res);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            });
    }, []);

      useEffect(()=>{
        if(cook){
            cookService.getCookServeSlots(
                props?.hasService?props?.date:date,
                cook,
                props?.hasService?props?.totalPeople:totalPeople,
                props?.hasService?props?.slotSize:undefined
            ).then((res)=>{
                setSlots(res);
            })
        }
      },[cook,date,props?.date,props?.hasService,props?.totalPeople,props?.slotSize,totalPeople])



    const refreshData = useCallback(() => {
        setCookLoading(true);
        const payload = {
            serviceId: serviceId,
            referenceId: props?.referenceId,
            houseId:props?.houseId,
            referenceModelName: ReferenceModelNameEnums.AREA,
            time: props?.time,
            slotSize: props?.slotSize,
            totalPeople: props?.totalPeople,
            date: props?.date,
        };
        areaService.getSlcCookServiceMappingForVisit(payload)
            .then((response) => {
                setCookData(response?.data);
                setCookLoading(false);
            })
            .catch((err) => {
                setCookLoading(false);
            });
    }, [serviceId, props?.referenceId, props?.time, props?.totalPeople, props?.slotSize, props?.date,props?.houseId]);


    const fetchData =useCallback(()=>{
        setCookLoading(true);
        const payload = {
            serviceId: serviceId,
            referenceId: record?.areaId,
            houseId:props?.houseId,
            referenceModelName: ReferenceModelNameEnums.AREA,
            time: time,
            totalPeople: totalPeople,
            date: moment(date).format("YYYY-MM-DD"),
        };
        areaService.getSlcCookServiceMappingForVisit(payload)
            .then((response) => {
                setCookData(response?.data);
                setCookLoading(false);
            })
            .catch((err) => {
                setCookLoading(false);
        });
    },[date,serviceId,time,totalPeople, record?.areaId,props?.houseId])
    const handleClick=()=>{
        if(serviceId&&time&&totalPeople&&date){
            fetchData();
            setClicked(true);
        }
        else{
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Missing Required Data",
                type: CustomSnackbarTypes.ERROR,
            });

        }
    }

    useEffect(()=>{
        if(clicked){
            fetchData();
        }
    },[serviceId,time,totalPeople,date,clicked,props?.hasService,fetchData])

    useEffect(() => {
        if(props?.hasService){
        refreshData();
        }
    }, [serviceId, refreshData,props?.hasService]);


    return (
        <>
        <CustomerPreferenceSummary
            customerPreference={record?.customerPreferences}
            customerId={record?.customerId}
        />
        {!loading &&
        <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: '12px', backgroundColor: 'background.paper' }}>
            <FIlterHeader>
                <FilterSection style={{ marginBottom: 0 }}>
                    <SectionHeader>
                        <WorkSpaceTitleRow>
                            <FilterIcon color="#1976d2" height={20} width={20} />
                            <SectionTitle>Filters</SectionTitle>
                        </WorkSpaceTitleRow>
                    </SectionHeader>
                </FilterSection>
            </FIlterHeader>
            <FilterContainer>
                <FilterTextField
                    select
                    label="Service"
                    size="small"
                    variant="outlined"
                    value={serviceId}
                    onChange={(e) => setServiceId(e.target.value)}
                    sx={{ minWidth: 200 }}
                >
                    <MenuItem value={0}>All</MenuItem>
                    {subData && subData.length > 0 && subData.map((service: any) => (
                        <MenuItem key={service?.id} value={service?.id}>{service?.name}</MenuItem>
                    ))}
                </FilterTextField>
                {!props?.hasService && (
                    <>
                        <DatePicker
                            mask=""
                            label="Select Date"
                            inputFormat="dd MMM yyyy"
                            value={date}
                            disabled={loading}
                            onChange={(newValue: any) => setDate(newValue)}
                            renderInput={(params) => (
                                <FilterTextField {...params} size="small" variant="outlined" />
                            )}
                        />
                        <FilterTextField
                            select
                            label="Start Time"
                            size="small"
                            variant="outlined"
                            value={time}
                            onChange={(e) => setTime(e.target.value)}
                            sx={{ minWidth: 200 }}
                        >
                            {CookSlotTimeEnumArray.map((t) => (
                                <MenuItem key={t} value={t}>{t}</MenuItem>
                            ))}
                        </FilterTextField>
                        <FilterTextField
                            select
                            label="Total People"
                            size="small"
                            variant="outlined"
                            value={totalPeople}
                            onChange={(e: any) => setTotalPeople(e.target.value)}
                            sx={{ minWidth: 150 }}
                        >
                            {Array.from({ length: 40 }, (_, i) => i + 1).map((e) => (
                                <MenuItem key={e} value={e}>{e}</MenuItem>
                            ))}
                        </FilterTextField>
                        <Box display="flex" gap="0.5rem" alignItems="center">
                            <Button variant="contained" size="medium" onClick={handleClick}>Fetch</Button>
                            <Button variant="contained" size="medium" onClick={handleReset}>Reset</Button>
                        </Box>
                    </>
                )}
            </FilterContainer>
        </Box>
       }
       <Box mt={2}>
       <TableWrapper>
         <TableContainer component={Paper} sx={{ borderRadius: "8px", overflowX: "auto" }}>
           <StyledTable sx={{ minWidth: 1200 }}>
             <TableHead>
               <TableRow sx={{ backgroundColor: "rgba(232,235,237,0.3) !important" }}>
                 <TableHeader sx={{ whiteSpace: 'nowrap' }}>Cook Id</TableHeader>
                 <TableHeader sx={{ whiteSpace: 'nowrap' }}>Cook Name</TableHeader>
                 <TableHeader sx={{ whiteSpace: 'nowrap' }}>Cook Type</TableHeader>
                 <TableHeader sx={{ whiteSpace: 'nowrap' }}>Slc Name</TableHeader>
                 <TableHeader sx={{ whiteSpace: 'nowrap' }}>Mapping Type</TableHeader>
                 <TableHeader sx={{ whiteSpace: 'nowrap' }}>Preference Tags</TableHeader>
                 <TableHeader sx={{ whiteSpace: 'nowrap' }}>Preference Matches</TableHeader>
                 <TableHeader sx={{ whiteSpace: 'nowrap' }}>Current Available</TableHeader>
                 <TableHeader sx={{ whiteSpace: 'nowrap' }}>Next Available</TableHeader>
                 <TableHeader sx={{ whiteSpace: 'nowrap' }}>Distance</TableHeader>
                 <TableHeader sx={{ whiteSpace: 'nowrap', minWidth: '160px' }}>Location Fetched</TableHeader>
                 <TableHeader sx={{ whiteSpace: 'nowrap' }}>Slots</TableHeader>
                 <TableHeader sx={{ whiteSpace: 'nowrap' }}>Assign Cook</TableHeader>
               </TableRow>
             </TableHead>
             {
               cookLoading?
               <CircularLoader/>:(
                   (cookData&&cookData?.primary&&cookData?.secondary&&(cookData?.primary.length>0||cookData?.secondary.length))
                   ?<CookServeTable data={[...cookData?.primary,...cookData?.secondary]} setDialogOpen={setDialogOpen} setCook={setCook} setAssignCookOpen={setAssignCookOpen} hasService={props?.hasService}/>
                   :<EmptyListPlaceholder message="No data Found"/>
               )
             }
           </StyledTable>
         </TableContainer>
       </TableWrapper>
       </Box>
        <ServeListSlotsDialog open={dialogOpen} setOpen={setDialogOpen} slots={slots} cookId={cook} date={props?.hasService?props?.date:formatDate(date)} noOfPeople={props?.hasService?props?.totalPeople:totalPeople} slotSize={props?.hasService?props?.slotSize:null}  />
        {
            props?.type&&
            (props?.type==="OMS"?
                <AssignCookServeList assignCookOpen={assignCookOpen} setAssignCookOpen={setAssignCookOpen} cookId={cook} mealServiceId={props?.mealServiceId}/>:
                <AssignCookOnTrialServeList assignCookOpen={assignCookOpen} setAssignCookOpen={setAssignCookOpen} cookId={cook} mealServiceId={props?.mealServiceId}/>
            )
        }
    </>
    )
}
export default CookServeList;


